import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-block" }
const _hoisted_2 = { class: "input-block" }
const _hoisted_3 = { class: "input-block" }
const _hoisted_4 = { class: "input-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PInput = _resolveComponent("PInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Подписант", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PInput, {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSign($event, 'name'))),
        modelValue: _ctx.modelValue.name,
        placeholder: "Имя",
        required: "",
        status: !!_ctx.modelValue.name.length,
        hint: "Поле обязательно для заполнения"
      }, null, 8, ["modelValue", "status"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PInput, {
        required: "",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSign($event, 'last_name'))),
        modelValue: _ctx.modelValue.last_name,
        placeholder: "Фамилия",
        status: !!_ctx.modelValue.last_name.length,
        hint: "Поле обязательно для заполнения"
      }, null, 8, ["modelValue", "status"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_PInput, {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSign($event, 'second_name'))),
        modelValue: _ctx.modelValue.second_name,
        placeholder: "Отчество",
        status: true
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_PInput, {
        required: "",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSign($event, 'phone'))),
        modelValue: _ctx.modelValue.phone,
        placeholder: "Телефон",
        status: !!_ctx.modelValue.phone.length,
        hint: "Поле обязательно для заполнения"
      }, null, 8, ["modelValue", "status"])
    ])
  ], 64))
}